export default (value) => {
    if (!value) {
        return 'Não'
    }
    return value ? 'Sim' : 'Não'
}

